module.exports = __webpack_public_path__ + "img/comentar-avatar.c57b9908.png";